/**
 * @fileoverview 共通コレクション collection
 *
 */
'use strict';
// Library Import
import _ from 'lodash';
import Backbone from 'backbone';
import 'backbone-validation';
// Util Import
import * as ConstUtil from '../util/ConstUtil';
import * as LogUtil from '../util/LogUtil';
import ConnectionUtil from '../util/ConnectionUtil';
import CommonModel from './model/CommonModel';

/**
 * 共通Collection
 *
 * @class CommonCollection
 * @extends {Backbone.Collection}
 */
class CommonCollection extends Backbone.Collection {
  constructor(param) {
    super();
    // ベースモデル
    this.baseModel = CommonModel;
    if (!_.isEmpty(param.baseModel)) {
      this.baseModel = param.baseModel;
    }

    // 一覧取得レスポンスで使用するキー名
    this.listResponseKey = '';
    if (!_.isEmpty(param.listResponseKey)) {
      this.listResponseKey = param.listResponseKey;
    }

    // Backbone ValidationをCollectionに取り込む
    _.extend(Backbone.Collection.prototype, Backbone.Validation.mixin);
    // Backbone Validationのpatternを拡張(空文字対策)
    _.extend(Backbone.Validation.validators, {
      extendPattern: function(value, attr, customValue, model) {
        if (value !== '') {
          return Backbone.Validation.validators.pattern(
            value,
            attr,
            customValue,
            model
          );
        }
      },
      // Backbone Validation 一致しないパターン
      notEqual: function(value, attr, customValue, model) {
        if (value !== customValue) {
          return 'not match ' + customValue;
        }
      }
    });
  }

  /**
   * 拡張preValidate
   *
   * @memberof CommonCollection
   * @param {Object} validationRule validationルール
   * @param {Object} data validationデータ
   * @return {string} エラー文字列
   */
  extendPreValidate(validationRule, data) {
    // validationルールをセット
    this.validation = validationRule;
    // validation対象
    let validationTarget = {};
    // チェック対象からvalidation対象を作成する
    for (let key of _.keys(this.validation)) {
      validationTarget[key] = '';
    }
    // validation対象にdataをマージする
    validationTarget = _.extend(validationTarget, data);
    // validationを行い結果を返す
    return this.preValidate(validationTarget);
  }

  /**
   * リストの型チェック
   *
   * @param {Array} list
   * @returns エラー
   * @memberof CommonCollection
   */
  checkListType(list) {
    if (!_.isArray(list)) {
      LogUtil.d(
        '[collectionValidationError]: checkListType Error. list key is ' +
          this.listResponseKey
      );
      return 'Validation Error';
    }
  }

  /**
   *  String型へ変換
   *
   * @param {Object} responseData レスポンスデータ
   * @memberof CommonCollection
   */
  convertResponseData(responseData) {
    if (_.isEmpty(responseData)) {
      return responseData;
    }
    // ディープコピー
    let responseString = _.cloneDeep(responseData);

    // int型の要素をstring型へ変換
    for (let item in responseString) {
      // 配列の場合
      if (_.isArray(responseString[item])) {
        for (let data of responseString[item]) {
          // 連想配列
          if (_.isObject(data)) {
            for (let key in data) {
              data[key] = this.converToString(data[key]);
            }
            continue;
          }
          // 連想配列以外
          data = this.converToString(data);
        }
        continue;
      }

      // 連想配列の場合
      if (_.isObject(responseString[item])) {
        let object = responseString[item];
        for (let key in object) {
          object[key] = this.converToString(object[key]);
        }
        continue;
      }

      // 上記以外の場合
      responseString[item] = this.converToString(responseString[item]);
    }
    return responseString;
  }

  /**
   * String型に変換
   *
   * @param {any} value 取得値
   * @returns {String} 変換後値
   * @memberof CommonCollection
   */
  converToString(value) {
    // nullの場合
    if (_.isNull(value)) {
      // 空白
      return '';
    }
    // undefined, boolの場合
    if (_.isUndefined(value) || _.isBoolean(value)) {
      // そのまま
      return value;
    }
    // 整数の場合
    if (_.isInteger(value)) {
      // 文字列変換
      return String(value);
    }
    // 上記以外 そのまま
    return value;
  }

  /**
   * 一覧取得
   *
   * @param {Object} api API情報
   * @param {Object} callback コールバック
   * @param {Object} payload ペイロード
   * @memberof CommonCollection
   */
  getList(api, callback, payload) {
    let self = this;
    // タイムスタンプを追加
    if (_.isObject(payload)) {
      // payload.timestamp = Date.now();
    }
    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: { params: payload }
    };

    // API呼び出し
    ConnectionUtil.callAPI(api, request, function(err, res) {
      if (err) {
        callback.failure(err);
        return;
      }
      self.setListResponse(res.data, callback);
      return;
    });
  }

  /**
   * 一覧取得レスポンスデータをセット
   *
   * @param {Object} responseData レスポンスデータ
   * @param {Object} callback コールバック
   * @memberof CommonCollection
   */
  setListResponse(responseData, callback) {
    // collection 初期化
    this.reset();
    let models = [];

    // チェックする値を渡してvalidation結果を取得
    let collectionValidationErrors = this.extendPreValidate(
      {
        // 半角数字（整数）チェック
        search_result_count: {
          required: true,
          extendPattern: ConstUtil.Common.REGULAR_EXPRESSION_PATTERN.P003
        },
        // リスト形式チェック
        [this.listResponseKey]: this.checkListType(
          responseData[this.listResponseKey]
        )
      },
      responseData
    );

    // validationエラーが存在する場合
    // if (collectionValidationErrors !== undefined) {
    //   LogUtil.d('[collectionValidationError]:' + collectionValidationErrors);
    //   callback.validationError();
    //   return;
    // }

    // 件数があるにも関わらず、実態が存在しない場合のチェック
    // ページ変更時に結果の変動があり、表示件数が0となる場合への対処
    if (
      _.isEmpty(responseData[this.listResponseKey]) &&
      responseData.search_result_count > 0
    ) {
      callback.pageError({
        isExistPage: false,
        message: ConstUtil.Message.COMMON.MESSAGE_052
      });
    }

    // list分baseModelを作成し追加する
    for (let data of responseData[this.listResponseKey]) {
      let model = new this.baseModel();
      // チェックする値を渡してvalidation結果を取得
      let modelValidationErrors = model.extendPreValidate(
        model.validation,
        data
      );
      // validationエラーが存在する場合
      if (modelValidationErrors !== undefined) {
        LogUtil.d('[modelValidationError]:' + modelValidationErrors);
        callback.validationError();
        continue;
      }
      // responseData を string型へ変換
      let stringData = this.convertResponseData(data);
      model.setProperties(stringData);
      models.push(model);
    }
    this.add(models);

    // responseDataからresponseを削除
    delete responseData[this.listResponseKey];

    // collection更新
    _.extend(this, responseData);
    callback.success();
  }

  /**
   *  詳細取得
   *
   * @param {Object} api API情報
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof CommonCollection
   */
  getDetail(api, callback, payload) {
    let self = this;
    // タイムスタンプを追加
    if (_.isObject(payload)) {
      payload.timestamp = Date.now();
    }

    // ディープコピー
    let apiInfo = _.cloneDeep(api);

    // URI置換
    apiInfo.URI = api.URI.replace(
      ConstUtil.Common.REGULAR_EXPRESSION_PATTERN.P010,
      payload.id
    );

    // idを削除
    delete payload.id;

    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: { params: payload }
    };

    // API呼び出し
    ConnectionUtil.callAPI(apiInfo, request, function(err, res) {
      if (err) {
        callback.failure(err);
        return;
      }
      self.setDetailResponse(res.data, callback);
      return;
    });
  }

  /**
   * 詳細取得レスポンスデータをセット
   *
   * @param {Object} responseData レスポンスデータ
   * @param {Object} callback コールバック
   * @memberof CommonCollection
   */
  setDetailResponse(responseData, callback) {
    // responseData を string型へ変換
    let responseString = this.convertResponseData(responseData);

    // collection 初期化
    this.reset();
    let models = [];

    // model作成
    let model = new this.baseModel();

    // チェックする値を渡してvalidation結果を取得
    let modelValidationErrors = model.extendPreValidate(
      model.validation,
      responseData
    );

    // validationエラーが存在する場合
    if (modelValidationErrors !== undefined) {
      LogUtil.d('[modelValidationError]:' + modelValidationErrors);

      callback.failure();
    }

    model.setProperties(responseString);
    models.push(model);
    this.add(models);
    callback.success();
  }

  /**
   *  編集
   *
   * @param {Object} api API情報
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof CommonCollection
   */
  edit(api, callback, payload) {
    // ディープコピー
    let apiInfo = _.cloneDeep(api);

    // URI置換
    apiInfo.URI = api.URI.replace(
      ConstUtil.Common.REGULAR_EXPRESSION_PATTERN.P010,
      payload.id
    );

    // idを削除
    delete payload.id;

    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: payload
    };

    // API呼び出し
    ConnectionUtil.callAPI(apiInfo, request, function(err, res) {
      if (err) {
        callback.failure(err);
        return;
      }
      callback.success();
      return;
    });
  }

  /**
   *  登録
   *
   * @param {Object} api API情報
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof CommonCollection
   */
  regist(api, callback, payload) {
    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: payload
    };

    // API呼び出し
    ConnectionUtil.callAPI(api, request, function(err, res) {
      if (err) {
        callback.failure(err);
        return;
      }
      callback.success();
      return;
    });
  }

  /**
   * 削除
   *
   * @param {Object} api API情報
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof CommonCollection
   */
  delete(api, callback, payload) {
    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: payload
    };

    // API呼び出し
    ConnectionUtil.callAPI(api, request, function(err, res) {
      if (err) {
        callback.failure(err);
        return;
      }
      callback.success();
      return;
    });
  }

  /**
   * CSV入力
   *
   * @param {Object} api API情報
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof CommonCollection
   */
  inputCsv(api, callback, payload) {
    let self = this;

    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: payload
    };

    // API呼び出し
    ConnectionUtil.callAPI(api, request, function(err, res) {
      if (err) {
        self.setInputCsvResponse(err, callback);
        return;
      }
      callback.success();
      return;
    });
  }

  /**
   * CSVエラーリストセット
   *
   * @param {Object} err エラー
   * @param {Object} callback コールバック
   * @memberof CommonCollection
   */
  setInputCsvResponse(err, callback) {
    // エラーがない場合
    if (_.isEmpty(err)) {
      // 登録失敗
      callback.failure();
      return;
    }
    if (_.isEmpty(err.response)) {
      // 登録失敗
      callback.failure();
      return;
    }
    if (_.isEmpty(err.response.data)) {
      // 登録失敗
      callback.failure();
      return;
    }
    if (_.isEmpty(err.response.data.error_list)) {
      // 登録失敗
      callback.failure();
      return;
    }
    // 応答エラーメッセージ
    callback.error(err.response.data.error_list);
  }

  /**
   * CSV出力
   *
   * @param {Object} api API情報
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof CommonCollection
   */
  outputCsv(api, callback, payload) {
    let self = this;

    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: { params: payload }
    };

    // API呼び出し
    ConnectionUtil.callAPI(api, request, function(err, res) {
      if (err) {
        callback.failure(err);
        return;
      }
      self.setOutputCsvResponse(res.data, callback);
      return;
    });
  }

  /**
   * CSV出力レスポンスデータをセット
   *
   * @param {Object} responseData レスポンスデータ
   * @memberof CommonCollection
   */
  setOutputCsvResponse(responseData, callback) {
    // チェックする値を渡してvalidation結果を取得
    let collectionValidationErrors = this.extendPreValidate(
      {
        download_url: {
          required: true
        },
        name: {
          required: true
        }
      },
      responseData
    );
    // validationエラーが存在する場合
    if (collectionValidationErrors !== undefined) {
      LogUtil.d('[collectionValidationError]:' + collectionValidationErrors);
      callback.failure();
      return;
    }
    // ダウンロードURLとファイル名をセット
    this.download_url = responseData.download_url;
    this.name = responseData.name;
    callback.success();
  }

  /**
   * アップロード情報取得
   *
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof CommonCollection
   */
  getUploadInfo(callback, payload) {
    let self = this;
    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: { params: payload }
    };
    // API呼び出し
    ConnectionUtil.callAPI(ConstUtil.Common.API_LIST.upload, request, function(
      err,
      res
    ) {
      if (err) {
        callback.failure(err);
        return;
      }
      self.setUploadInfo(res.data, callback);
      return;
    });
  }

  /**
   * アップロード情報取得成功
   *
   * @param {Object} responseData レスポンスデータ
   * @param {Object} callback コールバック
   * @returns
   * @memberof CommonCollection
   */
  setUploadInfo(responseData, callback) {
    let models = [];
    // チェックする値を渡してvalidation結果を取得
    let collectionValidationErrors = this.extendPreValidate(
      {
        // リスト形式チェック
        blob_list: this.checkListType(responseData['blob_list'])
      },
      responseData
    );
    // validationエラーが存在する場合
    if (collectionValidationErrors !== undefined) {
      LogUtil.d('[collectionValidationError]:' + collectionValidationErrors);
      callback.validationError();
      return;
    }
    // list分baseModelを作成し追加する
    for (let data of responseData['blob_list']) {
      let model = new this.baseModel();
      // チェックする値を渡してvalidation結果を取得
      let modelValidationErrors = model.extendPreValidate(
        model.uploadValidation,
        data
      );
      // validationエラーが存在する場合
      if (modelValidationErrors !== undefined) {
        LogUtil.d('[modelValidationError]:' + modelValidationErrors);
        callback.validationError();
        continue;
      }
      model.setProperties(data);
      models.push(model);
    }
    this.add(models);

    // responseDataからresponseを削除
    delete responseData['blob_list'];

    // collection更新
    _.extend(this, responseData);
    callback.success();
  }

  /**
   * ファイルアップロード
   *
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof CommonCollection
   */
  fileUpload(callback, payload) {
    let apiInfo = {
      URL: payload.url,
      METHOD: 'PUT'
    };

    let request = {
      headers: { 'x-ms-blob-type': 'BlockBlob' },
      data: payload.file
    };
    ConnectionUtil.callAPI(apiInfo, request, function(err, res) {
      if (err) {
        callback.failure(err);
        return;
      }
      callback.success(res);
      return;
    });
  }
}
export default CommonCollection;



// WEBPACK FOOTER //
// ./src/js/collection/CommonCollection.jsx